
// lazy component loading
const Home = () => import(/* webpackChunkName: "swee" */ './Home.vue');
const NewEvent = () => import(/* webpackChunkName: "swee" */ './NewEvent.vue');
const EventPreview = () => import(/* webpackChunkName: "swee" */ './EventPreview.vue');

const Event = () => import(/* webpackChunkName: "swee" */ './Event.vue');
const EventDashboard = () => import(/* webpackChunkName: "swee" */ './event/Dashboard.vue');
const EventInfo = () => import(/* webpackChunkName: "swee" */ './event/Info.vue');
const EventParticipations = () => import(/* webpackChunkName: "swee" */ './event/Participations.vue');
const EventReports = () => import(/* webpackChunkName: "swee" */ './event/Reports.vue');

export const routes = [
{
  path: 'swee',
  redirect: {name: 'swee.dashboard'},
  name: 'swee',
  //empty component just for base
  component: {template: '<router-view/>'},
  meta: {
    //trans: 'swee:title',
    root: true,
  },
  children: [
    {
      path: 'dashboard',
      name: 'swee.dashboard',
      component: Home,
      meta: {
        title: 'Swee',
        menu: false,
      },
      children: [
        {
          path: 'new/:lat?/:lng?',
          props: false,
          name: 'swee.new',
          component: NewEvent,
        },
        {
          path: ':id',
          name: 'swee.dashboard.event',
          component: EventPreview,
          props: true,
        },
      ],
    },
    {
      path: ':id',
      name: 'swee.event',
      component: Event,
      redirect: {name: 'swee.event.dashboard'},
      props: true,
      meta: {
        trans: 'swee:title_event',
        up: 'swee.dashboard',
        root: true,
      },
      children: [
        {
          path: 'dashboard',
          name: 'swee.event.dashboard',
          component: EventDashboard,
          meta: {
            trans: 'swee:dashboard.title',
            icon: 'dashboard',
          },
        },
        {
          path: 'info',
          name: 'swee.event.info',
          component: EventInfo,
          meta: {
            trans: 'swee:info.title',
            icon: 'info-round',
          },
        },
        {
          path: 'participations',
          name: 'swee.event.participations',
          component: EventParticipations,
          meta: {
            trans: 'contestdream:contests.titles.participations',
            icon: 'human',
          },
        },
        {
          path: 'reports',
          name: 'swee.event.reports',
          component: EventReports,
          meta: {
            trans: 'contestdream:contests.titles.reports',
            icon: 'bargraph',
          },
        },
      ],
    }
  ],
}
];

// TRANSLATIONS
import en from './i18n/en'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en})) {
  i18n.i18next.addResourceBundle(lang, 'swee', bundle);
}

import {routerTutorialGuard} from '@/providers/tutorial'
import tutorialsteps from './tutorial';
import maps from '@/providers/maps'

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'swee') {
      import(/* webpackChunkName: "swee" */ './scss/style.scss');
    }
  })
  routerTutorialGuard(router, 'swee', 'admin-swee-tutorial', tutorialsteps);
  //load google maps API before entering Swee
  router.beforeEach((to, from, next) => {
    if (to.name && to.name.split('.')[0] === 'swee') {
      return maps.then(() => next());
    } else {
      return next();
    }
  });
}


// WEBPACK FOOTER //
// ./src/apps/swee/index.js